
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import Testimonials from './TestimonialKeyword';
import Accordion from './Accordion';

function Punetotrimbakeshwarcab() {



    const cardData =
    {
        keyword: 'Pune to Trimbakeshwar Cab Fare',
        heading: 'Meghana Cab : Pune to Trimbakeshwar Cab Fare',
        headingDescription: 'Meghana Cab offers affordable Pune to Trimbakeshwar Cab Fare options, ensuring a comfortable and spiritual journey to one of Maharashtra’s most sacred Jyotirlingas. Whether you are planning a pilgrimage, a family trip, or a peaceful weekend getaway, our clean and well-maintained cabs with experienced drivers guarantee a smooth and timely ride. Choose from a range of vehicle options to suit your travel needs and enjoy transparent pricing with no hidden charges. With 24/7 customer support, flexible booking, and professional service, Meghana Cab is your trusted choice for Pune to Trimbakeshwar travel. Book now for a reliable and hassle-free pilgrimage experience.',


        top: 'Top Places to Visit in Trimbakeshwar with Meghana Cab',

"topPlaces": [
  {
    "title": "Trimbakeshwar Shiva Temple",
    "description": "One of the twelve Jyotirlingas, this 13th-century Nagara-style temple was built by Peshwa Balaji Baji Rao and later renovated by Ahilyabai Holkar. It features a unique trinity lingam (Brahma, Vishnu, Shiva) beneath a jewelled crown, the Kushavarta kund as the source of the Godavari River, and rich stone carvings. It stands amidst the Brahmagiri hills and is integral to several annual religious rites and pilgrimages." 
  },
  {
    "title": "Brahmagiri Hills and Kushavarta",
    "description": "These hills cradle the origin of the Godavari River. Pilgrims climb a series of steps to reach the Kushavarta kund where the sacred river begins. The trek through evergreen forest offers spiritual significance and panoramic valley views." 
  },
  {
    "title": "Anjaneri Fort and Hills",
    "description": "Located about 20 km from Trimbakeshwar, this hill is believed to be the birthplace of Lord Hanuman. It offers trekking trails, ancient Jain caves, temples, and wonderful views of the Western Ghats. A popular destination during the monsoon." 
  },
  {
    "title": "Harihar Fort (Harshagad)",
    "description": "Ruins of a hill fort perched at around 1,120 m in the Tryambak range. Known for steep stone-cut steps and sweeping vistas over the Godavari valley. Accessible via Nirgudpada or Harshewadi villages and ideal for a challenging day trek." 
  },
  {
    "title": "Gorakhnath Gufa and Ganga Dwar",
    "description": "Located along the Brahmagiri trek, these ancient cave shrines are associated with Sage Gorakhnath. The Ganga Dwar spring emerges nearby, regarded as another sacred birthplace of the Godavari River. They provide a calm retreat within the forest." 
  },
  {
    "title": "Nashik Trimbak Simhastha (Kumbh Mela)",
    "description": "Held every 12 years at the Trimbak–Nashik region, this Maha Kumbh Mela involves ritual bathing in the Godavari River and draws millions of pilgrims. Extensive infrastructure development, including roads and pilgrim facilities, has been made ahead of the 2026–27 event." 
  },
  {
    "title": "Kalsarpa, Narayan Nagbali and Other Rituals",
    "description": "Trimbakeshwar is renowned for performing spiritual purification rites like Kalsarpa Shanti and Narayan Nagbali, often done by pilgrims seeking relief from ancestral or astrological afflictions. Ceremonies take place along riverbanks and temple precincts." 
  },
  {
    "title": "Coin Museum, Ramkund, Muktidham (near Nashik)",
    "description": "Within 30–40 km of Trimbakeshwar, these Nashik attractions include the Coin Museum (numismatic heritage), Ramkund (holy ghat on the Godavari), and the marble-constructed Muktidham Temple replicating the 12 Jyotirlingas."
  },
  {
    "title": "Saptashrungi Devi Temple",
    "description": "About 60 km from Trimbakeshwar, this cliff-top shrine to Goddess Saptashrungi stands atop steep steps and offers sweeping panoramic views. It is a major religious site, especially during festivals and the monsoon season."
  },
  {
    "title": "Anjaneri Waterfall and Walks",
    "description": "During monsoons, the trails to Anjaneri and Brahmagiri light up with seasonal waterfalls and lush greenery. Ideal for nature walks, short treks, picnics, and photography in a misty Western Ghats setting."
  }
],

"services": [
    {
        "name": "Pune to Trimbakeshwar Cab Price",
        "description": "The one-way cab fare from Pune to Trimbakeshwar starts at ₹2,200, depending on the vehicle type and service provider. Round-trip fares typically range from ₹4,500 to ₹7,500, offering flexibility for pilgrims and tourists alike."
    },
    {
        "name": "Affordable Taxi Fare Pune to Trimbakeshwar",
        "description": "Budget-friendly taxi options are available, with fares starting from ₹2,200 for a one-way trip. Providers like Tiger Cabs and GaadiCab offer competitive pricing without compromising on comfort or safety."
    },
    {
        "name": "One Way Cab Fare Pune to Trimbakeshwar",
        "description": "One-way cab fares from Pune to Trimbakeshwar vary based on vehicle type and provider. For instance, GaadiCab offers sedan fares starting at ₹2,500, while Uber Intercity's fares begin around ₹4,451."
    },
    {
        "name": "Round Trip Fare Pune to Trimbakeshwar",
        "description": "Round-trip fares for a Pune to Trimbakeshwar journey can range from ₹4,500 to ₹7,500, depending on the vehicle and service provider. For example, MakeMyTrip lists SUV round-trip fares starting at ₹4,670."
    },
    {
        "name": "Online Fare Estimate Pune to Trimbakeshwar",
        "description": "Online platforms like MakeMyTrip and Uber Intercity provide fare estimates for Pune to Trimbakeshwar trips. For instance, Uber Intercity offers fares starting at ₹4,451 for a one-way trip."
    },
    {
        "name": "Pune to Trimbakeshwar AC Cab Fare",
        "description": "AC cab fares for the Pune to Trimbakeshwar route vary by vehicle type. For example, Payal Cab offers AC sedan fares starting at ₹3,499, while Clear Cabs Rental lists AC sedan fares at ₹3,499 for a one-way trip."
    },
    {
        "name": "SUV Taxi Pune to Trimbakeshwar Price",
        "description": "SUV taxi fares for the Pune to Trimbakeshwar route start from ₹3,999 for a one-way trip. Providers like Payal Cab and Clear Cabs Rental offer SUVs such as Toyota Innova and Mahindra Xylo for this route."
    },
    {
        "name": "Best Cab Rate Pune to Trimbakeshwar",
        "description": "The best cab rates for the Pune to Trimbakeshwar route depend on vehicle type and service provider. For instance, GaadiCab offers sedan fares starting at ₹2,500, while Uber Intercity's fares begin around ₹4,451."
    },
    {
        "name": "Pune to Trimbakeshwar Sedan Fare",
        "description": "Sedan fares for the Pune to Trimbakeshwar route start from ₹2,500 for a one-way trip. Providers like GaadiCab and Payal Cab offer sedan options such as Swift Dzire and Toyota Etios for this route."
    },
    {
        "name": "Transparent Pricing Pune to Trimbakeshwar",
        "description": "Service providers like Tiger Cabs and Clear Cabs Rental offer transparent pricing with no hidden charges. For example, Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip, inclusive of driver allowance."
    },
    {
        "name": "Fare Comparison Pune to Trimbakeshwar Taxi",
        "description": "Comparing fares from different providers can help you find the best deal. For instance, Uber Intercity offers fares starting at ₹4,451, while Payal Cab lists sedan fares at ₹3,499 for a one-way trip."
    },
    {
        "name": "Pune to Trimbakeshwar Car Hire Cost",
        "description": "Car hire costs for the Pune to Trimbakeshwar route vary based on vehicle type and provider. For example, DDcab offers sedan hire starting at ₹3,788, while Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip."
    },
    {
        "name": "Cheap Pune to Trimbakeshwar Cab",
        "description": "Affordable cab options are available for the Pune to Trimbakeshwar route, with fares starting from ₹2,200 for a one-way trip. Providers like Tiger Cabs and GaadiCab offer competitive pricing without compromising on comfort."
    },
    {
        "name": "Toll Charges Included Fare Pune to Trimbakeshwar",
        "description": "Some service providers include toll charges in their fares. For instance, Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip, inclusive of driver allowance, but excludes toll and parking charges."
    },
    {
        "name": "Trimbakeshwar Darshan Cab Fare from Pune",
        "description": "Cab fares for Trimbakeshwar Darshan from Pune vary based on vehicle type and provider. For example, Payal Cab offers sedan fares starting at ₹3,499 for a one-way trip, while Clear Cabs Rental lists sedan fares at ₹3,499 for a one-way trip."
    }
],

"tableData": [
    ["Service Provider", "Vehicle Type", "One-Way Fare (₹)", "Round-Trip Fare (₹)", "Additional Charges"],
    ["GaadiCab", "Sedan", "2,500", "5,000", "Toll, Parking, Driver Allowance"],
    ["Uber Intercity", "Sedan", "4,451", "8,902", "Toll, Parking, Driver Allowance"],
    ["Payal Cab", "Sedan", "3,499", "6,998", "Toll, Parking, Driver Allowance"],
    ["Clear Cabs Rental", "Sedan", "3,499", "6,998", "Toll, Parking, Driver Allowance"],
    ["Tiger Cabs", "Sedan", "2,200", "4,400", "Toll, Parking, Driver Allowance"]
],









"whychoose": [
    {
        "WhyChooseheading": "Affordable Pune to Trimbakeshwar Cab Fare",
        "WhyChoosedescription": "Meghana Cab offers competitive and transparent cab fares for travel from Pune to Trimbakeshwar, one of the most sacred Jyotirlinga shrines in India. Our fares are designed to be budget-friendly without compromising on comfort and reliability—ideal for pilgrims and tourists alike."
    },
    {
        "WhyChooseheading": "No Hidden Charges or Surprise Costs",
        "WhyChoosedescription": "Our Pune to Trimbakeshwar cab fare includes tolls, fuel charges, driver allowance, and taxes. We believe in honest pricing, so you always know exactly what you’re paying—no last-minute surprises or hidden fees."
    },
    {
        "WhyChooseheading": "Wide Range of Cab Options for Every Budget",
        "WhyChoosedescription": "Choose from economical hatchbacks, spacious sedans, premium SUVs, and tempo travellers. Whether you’re traveling solo or with a group, we have the right cab at the right fare to suit your needs."
    },
    {
        "WhyChooseheading": "Safe and Comfortable Long-Distance Travel",
        "WhyChoosedescription": "Our cabs are well-maintained, sanitized, and equipped with AC and ample legroom for the 6- to 7-hour journey to Trimbakeshwar. Enjoy a smooth ride through scenic routes with total peace of mind."
    },
    {
        "WhyChooseheading": "Experienced Drivers with Pilgrimage Route Knowledge",
        "WhyChoosedescription": "Our courteous drivers are familiar with the Pune–Trimbakeshwar route and can guide you to nearby attractions or stopover points. They ensure your journey is both spiritual and stress-free."
    },
    {
        "WhyChooseheading": "Flexible One-Way and Round Trip Cab Fare Packages",
        "WhyChoosedescription": "We offer flexible fare options including one-way drops, same-day returns, and multi-day round trips to accommodate your travel plans and temple visit timings."
    },
    {
        "WhyChooseheading": "24/7 Booking with Immediate Fare Quotes",
        "WhyChoosedescription": "Book your Pune to Trimbakeshwar cab anytime via our website, app, or helpline. You’ll get instant fare details, booking confirmation, and live driver tracking for added convenience."
    },
    {
        "WhyChooseheading": "Ideal for Pilgrims, Families, and Senior Citizens",
        "WhyChoosedescription": "Our cab service is tailored for comfort and ease of travel, making it perfect for elderly pilgrims and families heading to Trimbakeshwar for darshan, rituals, or a peaceful spiritual retreat."
    }
]









































    }

const faqData = [
    {
        question: "What is the cab fare from Pune to Trimbakeshwar with Meghana Cab?",
        answer: "The cab fare from Pune to Trimbakeshwar varies based on vehicle type and trip duration. Please contact Meghana Cab at +91 9075462128 for detailed fare information."
    },
    {
        question: "How can I book a cab from Pune to Trimbakeshwar?",
        answer: "You can book your Pune to Trimbakeshwar cab by calling Meghana Cab or via our website for easy booking."
    },
    {
        question: "What vehicle options are available for Pune to Trimbakeshwar trips?",
        answer: "We offer sedans, SUVs, and tempo travellers depending on your group size and comfort needs."
    },
    {
        question: "Are Meghana Cab services available for one-way and round-trip to Trimbakeshwar?",
        answer: "Yes, both one-way and round-trip services are available."
    },
    {
        question: "What does the Pune to Trimbakeshwar cab fare include?",
        answer: "The fare typically includes driver charges, fuel, tolls, and vehicle maintenance. Additional charges may apply depending on your trip specifics."
    },
    {
        question: "Are Meghana Cab vehicles sanitized for safety?",
        answer: "Yes, all vehicles are regularly cleaned and sanitized to ensure passenger safety."
    },
    {
        question: "How long does the Pune to Trimbakeshwar trip take by cab?",
        answer: "The trip generally takes about 3 to 4 hours depending on traffic conditions."
    },
    {
        question: "What payment methods are accepted for Pune to Trimbakeshwar cab bookings?",
        answer: "We accept UPI, credit/debit cards, net banking, and cash payments."
    },
    {
        question: "Is Meghana Cab available 24/7 for Pune to Trimbakeshwar trips?",
        answer: "Yes, our services operate round-the-clock to suit your schedule."
    },
    {
        question: "How can I contact Meghana Cab for Pune to Trimbakeshwar cab services?",
        answer: "Call Meghana Cab at +91 9075462128 to book or inquire about Pune to Trimbakeshwar cab fares and services."
    }
];

const testimonialsData = [
    {
        name: 'Mr. Ashok More',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“The Pune to Trimbakeshwar cab fare was reasonable, and the trip was comfortable with Meghana Cab.”',
    },
    {
        name: 'Ms. Snehal Kulkarni',
        designation: 'Customer',
        rating: [1, 1, 1, 1, 1],
        text: '“I had a great experience traveling to Trimbakeshwar with Meghana Cab. The driver was friendly and punctual.”',
    },
];






































































    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9075462128",
            "+91 8452916550",

        ],
        email: "booking@meghanacabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Online Cab Booking in Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Kolhapur Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Satara Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Hyderabad Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune to Bangalore Cab",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Pune to Indore Cab",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Gujarat Cab",
        },

        {
            place: "/images/keyword/8.jpg",
            text: "Pune to Lonavala Taxi",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Pune to Jejuri Cab",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Local Taxi Service in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pune to Lavasa Cab",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune to Kashid Beach Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "One Way Cab Pune",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Round Trip Cab",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Taxi Service Near Me",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Car Hire in Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Seater Car on Rent in Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Cab Service in Pimpri Chinchwad",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune Taxi Cab Services",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune Airport Taxi",
        },

        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Rajasthan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Matheran Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Pandharpur Cab",
        },
        {
            place: "/images/keyword/24.jpg",
            text: " Pune to Mumbai Cabs",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Mumbai Airport Cab ",
        },
        {
            place: "/images/keyword/26.jpg",
            text: " Pune to Mumbai Taxi",
        },
    ];


    const images = [
        { src: "/images/booking/1.jpg", alt: "Image 1" },
        { src: "/images/booking/5.jpg", alt: "Image 1" },
        { src: "/images/booking/2.jpg", alt: "Image 1" },
        { src: "/images/booking/3.jpg", alt: "Image 1" },
        { src: "/images/booking/4.jpg", alt: "Image 1" },
        { src: "/images/booking/7.jpg", alt: "Image 1" },
        { src: "/images/booking/8.jpg", alt: "Image 1" },
        { src: "/images/booking/9.jpg", alt: "Image 1" },
        { src: "/images/booking/6.jpg", alt: "Image 1" },

    ];




const fareSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Trimbakeshwar Cab Fare",
  "image": "https://www.meghanacabs.com/assets/images/pune-to-trimbakeshwar-cab.jpg",
  "description": "Check affordable Pune to Trimbakeshwar cab fares with Meghana Cabs. Transparent pricing on AC sedans, SUVs, one way and round trip taxi services including toll charges.",
  "brand": {
    "@type": "Brand",
    "name": "Meghana Cabs"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "1600",
    "availability": "https://schema.org/InStock",
    "url": "https://www.meghanacabs.com/pune-to-trimbakeshwar-cab-fare"
  }
};








    return (
        <div>

<Helmet>
  <title>Pune to Trimbakeshwar Cab Fare | Meghana Cabs</title>
  <meta
    name="description"
    content="Check affordable Pune to Trimbakeshwar cab fares with Meghana Cabs. Transparent pricing on AC sedans, SUVs, one way and round trip taxi services including toll charges."
  />
  <meta
    name="keywords"
    content="Pune to Trimbakeshwar Cab Price, Affordable Taxi Fare Pune to Trimbakeshwar, One Way Cab Fare Pune to Trimbakeshwar, Round Trip Fare Pune to Trimbakeshwar, Online Fare Estimate Pune to Trimbakeshwar, Pune to Trimbakeshwar AC Cab Fare, SUV Taxi Pune to Trimbakeshwar Price, Best Cab Rate Pune to Trimbakeshwar, Pune to Trimbakeshwar Sedan Fare, Transparent Pricing Pune to Trimbakeshwar, Fare Comparison Pune to Trimbakeshwar Taxi, Pune to Trimbakeshwar Car Hire Cost, Cheap Pune to Trimbakeshwar Cab, Toll Charges Included Fare Pune to Trimbakeshwar, Trimbakeshwar Darshan Cab Fare from Pune"
  />
  <script type="application/ld+json">
    {JSON.stringify(fareSchema)}
  </script>
</Helmet>



            <section className="page-title centred">
                <div className="bg-layer" style={{ backgroundImage: 'url(/images/page-header-bg.jpg)' }}></div>
                <div className="auto-container">
                    <div className="content-box">

                        <h1>{cardData.keyword}</h1>
                    </div>
                </div>
            </section>




            <section>
                <div className="container-fluid" >
                    <div className="row ">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/37.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#F2614C', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                             <h3 className='pt-md-3 text-dark'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                <h2 className='whycolor py-3'>Why Choose us for  {cardData.keyword}</h2>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark darkcolor">FAQS {cardData.keyword} For Meghana Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">
                                                <Accordion data={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <Testimonials testimonials={testimonialsData} />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3 className=' text-dark'>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F1604F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F1604F' }}>
                                            <h4 className=" lead fw-semibold whitt text-darkk">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919075462128" className="d-block  text-white">+91 9075462128</a>
                                                <a href="tel:+918452916550" className="d-block  text-white">+91 8452916550</a>



                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Email</h4>
                                                <a href="mailto:booking@meghanacabs.com" className=" text-white d-block">
                                                    booking@meghanacabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#F1604F' }}>
                                                <h4 className=" fw-semibold lead whitt text-darkk">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Meghana Cab  <br />
                                                        Yelwande Wasti. Opp Vithal Lawans, Laxmi Chowk, Hinjawadi, Pune - 411057
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetotrimbakeshwarcab;